// src/components/common/PresentServiceInfo.jsx
import React from "react";

function PresentServiceInfo({ active = false, category }) {
    if (!active) {
        return (
            <div className="text-xl p-3 bg-gray-50 rounded mb-2">
                <span className="font-semibold">Cadeauservice actief: Nee</span>
            </div>
        );
    }

    return (
        <div>
            <div className="text-xl p-3 bg-gray-50 rounded mb-2">
                <span className="font-semibold">Cadeauservice actief: Ja</span>
            </div>
            <div className="text-xl p-3 bg-gray-50 rounded mb-2">
                <span className="font-semibold">Cadeauservice categorie: {category}</span>
            </div>
        </div>
    );
}

export default PresentServiceInfo;